export { default as NarrowCta } from './NarrowCta';
